export class Histogram {

    startOver = true;
    isProgressTime = true;

    speedSlices: number[] = [];
    lastPosition = 1;
    currentInterval = 1;
    lastSliceTransferredBytes: number;

    alpha = 0.2;
    lowpassFloatList: number[] = [];

    createHistogramValues(transferredBytesList: number[], timeList: number[], progressData: number, progressTime: number, totalTime: number, numberOfSlices: number): number[] {
        if (transferredBytesList.length > 1 && timeList.length > 1) {

            let startTime: number = timeList[0];
            let lastEntry: number = Math.min(transferredBytesList.length, timeList.length) - 1;
            let endTime: number = timeList[lastEntry];

            let timeIntervalSlice = 0;

            if (progressTime > progressData) {
                timeIntervalSlice = totalTime / numberOfSlices;
                if (!this.isProgressTime) {
                    this.startOver = true;
                } else {
                    this.isProgressTime = true;
                }
            } else {
                let timeRunDifference: number = endTime - startTime;
                timeIntervalSlice = timeRunDifference * 100.0 / (numberOfSlices + 1) / progressData;
                this.startOver = true;
                this.isProgressTime = false;
            }

            if (this.startOver) {
                this.startOver = false;
                this.speedSlices = [];

                this.lastPosition = 1;
                this.currentInterval = 1;
                this.lastSliceTransferredBytes = null;
                this.lowpassFloatList = [];
            }

            let isLastRun = false;
            if (progressData >= 0.95 || progressTime >= 0.95) {
                isLastRun = true;
            }

            // add new values to the speed array. Does not start over to save computation.
            this.addNewValues(transferredBytesList, timeList, startTime, timeIntervalSlice, numberOfSlices, isLastRun);
            let lowpassedSpeedSlices = this.lowpassFilter(this.speedSlices);

            // return lowpassedSpeedSlices
            return this.speedSlices;
        }
    }

    private addNewValues(transferredBytesList: number[], timeList: number[], startTime: number, timeIntervalSlice: number, numberOfSlices: number, isLastRun: boolean) {
        let lastCount: number = Math.min(transferredBytesList.length, timeList.length) - 1;

        if (this.lastSliceTransferredBytes == undefined || this.lastSliceTransferredBytes == null) {
            this.lastSliceTransferredBytes = transferredBytesList[0];
        }

        for (let i = this.currentInterval; i <= numberOfSlices; ++i) {
            let lastPositionTemp: number = this.lastPosition;

            let currentTime: number = timeList[lastPositionTemp];
            let endTimeSlice: number = i * timeIntervalSlice + startTime;
            while ((currentTime < endTimeSlice) && (lastPositionTemp < lastCount)) {
                lastPositionTemp = lastPositionTemp + 1;
                currentTime = timeList[lastPositionTemp];
            }
            if (lastPositionTemp < lastCount || isLastRun) {
                let timeOutOfSlice: number = currentTime - endTimeSlice;
                let percentOutOfSlice: number = timeOutOfSlice / (currentTime - timeList[lastPositionTemp - 1]);
                let transferredBytesAtEndOfSlice: number = transferredBytesList[lastPositionTemp] - (transferredBytesList[lastPositionTemp] - transferredBytesList[lastPositionTemp - 1]) * percentOutOfSlice;

                // calculate speed in Mbps and add to array
                let speed: number = this.byteToMbit((transferredBytesAtEndOfSlice - this.lastSliceTransferredBytes) / timeIntervalSlice * 1000);
                this.speedSlices.push(speed);

                // remember position for future
                this.lastSliceTransferredBytes = transferredBytesAtEndOfSlice;
                this.currentInterval = i + 1;
            }
            this.lastPosition = lastPositionTemp;
        }
    }

    private byteToMbit(inByte: number): number {
        return inByte * 8 / 1024 / 1024;
    }

    private lowpassFilter(input: number[]): number[] {
        if (input.length > 0) {
            if (this.lowpassFloatList.length == 0) {
                // multiply with 0.8 to start with a low value in the histogram, just for cosmetics in case the first value is high because of the buffer being filled. More of a problem for slow connections.
                this.lowpassFloatList.push(0.8 * input[0]);
            }
            for (let i = this.lowpassFloatList.length; i < input.length; ++i) {
                this.lowpassFloatList.push(this.lowpassFloatList[i - 1] + this.alpha * (input[i] - this.lowpassFloatList[i - 1]));

            }
            return this.lowpassFloatList;
        } else {
            let array: number[] = [];
            for (let i = 0; i < input.length; ++i) {
                array.push(input[i]);
            }
            return array;
        }
    }

}
